const website = require('./website')
const dePages = require('./translations/de/pages')
const enPages = require('./translations/en/pages')

module.exports = {
  'de-de': {
    default: true,
    path: 'de',
    locale: 'de-de',
    siteLanguage: 'de',
    ogLang: 'de_DE',
    defaultTitle: website.title,
    defaultTitleAlt: website.titleAlt,
    defaultDescription: 'Basierend auf gatsby-starter-prismic mit Unterstützung für Lokalisierung (i18n)',
    headline: 'Schreiben und Veröffentlichen für LekoArts',
    category: 'Kategorie',
    categories: 'Kategorien',
    was: 'wurde',
    were: 'wurden',
    tagged: 'markiert mit',
    recent: 'Neue',
    projects: 'Projekte',
    allCategories: 'Alle Kategorien',
    entries: 'Einträge',
    langGerman: 'Deutsch',
    langEnglish: 'Englisch',
    pageIndex: 'Tach auch!',
    pageImprint: 'Impressum',
    pagePrivacy: 'Datenschutz',
    pageBlog: 'Blog',
    pageContact: 'Kontakt',
    pageUses: 'Marek benutzt...',
    pageNow: 'Marek jetzt...',
    contact: dePages.contact,
    contactForm: dePages.contactForm,
  },
  'en-us': {
    path: 'en',
    locale: 'en-us',
    siteLanguage: 'en',
    ogLang: 'en_US',
    defaultTitle: website.title,
    defaultTitleAlt: website.titleAlt,
    defaultDescription: website.description,
    headline: website.headline,
    category: 'Category',
    categories: 'Categories',
    was: 'was',
    were: 'were',
    tagged: 'tagged with',
    recent: 'Recent',
    projects: 'projects',
    allCategories: 'All categories',
    entries: 'entries',
    langGerman: 'German',
    langEnglish: 'English',
    pageIndex: 'Hello!',
    pageImprint: 'Imprint',
    pagePrivacy: 'Privacy Policy',
    pageBlog: 'Blog',
    pageContact: 'Contact',
    pageUses: 'Uses',
    pageNow: 'Now',
    contact: enPages.contact,
    contactForm: enPages.contactForm,
  },
}